export default __webpack_public_path__ + "static/media/ticket_booth_demo_image.d346995d.gif";